/*
 * @Author: yanyongchao
 * @Date: 2018-12-30 23:42:31
 * @Last Modified by: yanyongchao
 * @Last Modified time: 2018-12-30 23:42:31
 */
import md5 from 'blueimp-md5'
export default md5
